import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { hangUpCall, listenCall } from "../../actions/getAgentConfig";
import { toastErrorMsg } from "../../utils/utils";
import { set_userInteraction } from "../../actions/common.js";
import onCall from "../../assets/img/onCall.svg";
import "../../utils/styles/icomoon-roboto-style.css";
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";
import { showWebphone } from '../../actions/call';

class OnGoingCall extends Component {
  constructor(props) {
    super(props);
    this.state = {
        link_disabled: false,
    };
  }
  onClose() {
    this.props.handleClose("showOnGoingcallModal");
  }
  onUserInteracted() {
    this.props.set_userInteraction(true);
  }

  getRawCallId(call_id)
  {
      // console.log('call_id', call_id);
      let raw_call_id = '';
      let ivr = '';
      let body_id = '';
      let last = '';

      const is_test_ivr = (call_id.substring(0, 1) === '1');
      if (is_test_ivr)
      {
          ivr = call_id.substring(0, 3);
          body_id = call_id.substring(3, 13)
          last = call_id.substring(13)
      }
      else
      {
          ivr = call_id.substring(0, 2);      
          body_id = call_id.substring(2, 12)
          last = call_id.substring(12)    
      }

      raw_call_id = ivr + '-' + body_id + '.' + last;
      // console.log('raw_call_id', raw_call_id);
      
      return raw_call_id;
  }

  onListen() {

    if (! this.state.link_disabled)
    {
      // console.log('CLICK no more!! listenCall');
      this.state.link_disabled = true;
      setTimeout(() => { 
          this.state.link_disabled = false;
          // console.log('CLICK ok!! listenCall');
      }, 2000);

      this.onUserInteracted();

      let raw_call_id = this.getRawCallId(this.props.agentProperties.user_Info.call_id);
      // console.log(this.getRawCallId(this.props.agentProperties.user_Info.call_id));
      // OLD: let raw_call_id = this.props.agentProperties.user_Info.call_id;

      const payload = {
        whisper_type: "Spy",
        extension: this.props.agentInfo.extension,
        call_id: raw_call_id,
      };

      // Avisar de inicio de sesion de Spy.
      window.mq.send(`/exchange/signal.${this.props.agentInfo.client_id}/user.${this.props.agentInfo.agent_id}`, {}, `{"tag":"whiper_session_begin","data":"${payload.whisper_type}"}`);

      this.props.listenCall(payload).then((res) => {
        
        // if (!res.data.action_id) {
        if (! res.data.result) {
          toastErrorMsg(
            this.props.translations.callFailed[this.props.selectedLanguage],
            this,
            "callFailedToast"
          );
        }
        this.onClose();
      });
    }
  }

  onAdvice() {

    if (! this.state.link_disabled)
    {
      // console.log('CLICK no more!! listenCall');
      this.state.link_disabled = true;
      setTimeout(() => { 
          this.state.link_disabled = false;
          // console.log('CLICK ok!! listenCall');
      }, 2000);

      this.onUserInteracted();

      let raw_call_id = this.getRawCallId(this.props.agentProperties.user_Info.call_id);
      // console.log(this.getRawCallId(this.props.agentProperties.user_Info.call_id));
      // OLD: let raw_call_id = this.props.agentProperties.user_Info.call_id;

      const payload = {
        whisper_type: "Adviser",
        extension: this.props.agentInfo.extension,
        call_id: raw_call_id,
      };

      // Avisar de inicio de sesion de Advice.
      window.mq.send(`/exchange/signal.${this.props.agentInfo.client_id}/user.${this.props.agentInfo.agent_id}`, {}, `{"tag":"whiper_session_begin","data":"${payload.whisper_type}"}`);

      this.props.listenCall(payload).then((res) => {
        // if (!res.data.result) {
        if (!res.data.result) {
          toastErrorMsg(
            this.props.translations.callFailed[this.props.selectedLanguage],
            this,
            "callFailedToast"
          );
        }
        this.onClose();
      });
    }
  } 

  onHangUp() {

    if (! this.state.link_disabled)
    {
      // console.log('CLICK no more!! listenCall');
      this.state.link_disabled = true;
      setTimeout(() => { 
          this.state.link_disabled = false;
          // console.log('CLICK ok!! listenCall');
      }, 2000);
      
      // console.log('ON HANG UP');  

      this.onUserInteracted();
      this.props.hangUpCall(this.props.agentProperties.user_Info).then((res) => {
        if (!res.data.result) {
            toastErrorMsg(
              this.props.translations.noServiceFound[this.props.selectedLanguage],
              this,
              "callFailedToast"
            );
        }
        this.onClose();
      });
    }

  }

  render() {
    return (
      <Modal
        show={this.props.showOnGoingcallModal}
        onHide={() => this.onClose()}
        backdrop="static"
        bsSize="sm"
        className="modal-class"
        // style={{Width:"250px",display:"block",justifyContent:"center"}}
      >
        <Modal.Header
          className={`modal-content${this.props.theme} modal-header${this.props.theme}`}
          closeButton
        >
          <Modal.Title>
            {this.props.translations.onGoingCall[this.props.selectedLanguage]}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className={`modal-content${this.props.theme}`}
          style={{ textAlign: "center" }}
        >
          {Object.keys(this.props.agentProperties).length > 0 && (
            <div
              style={{
                width: "100%",
              }}
            >
              <b>
                {this.props.agentProperties.user_Info.from
                  ? "From: " + this.props.agentProperties.user_Info.from
                  : " None "}{" "}
                <span
                  style={{ fontSize: 11 }}
                  className={`icon ${"icon-arrow-long-right"}`}
                />
                {this.props.agentProperties.user_Info.to
                  ? " To: " + this.props.agentProperties.user_Info.to
                  : " None "}
              </b>
              <br />
              {/* <img
                // id={`${type}_${user.id}`}
                src={onCall}
                height="24"
                alt=""
              /> */}
              <span
                style={{ fontSize: 11 }}
                className={`icon ${
                  this.props.agentProperties.user_Info.type === "outgoing"
                    ? "icon-arrow-up"
                    : "icon-arrow-down"
                }`}
              />
              {this.props.agentProperties.user_Info.type === "outgoing"
                ? ` ${
                    this.props.translations.outgoingCall[
                      this.props.selectedLanguage
                    ]
                  }`
                : ` ${
                    this.props.translations.incomingCall[
                      this.props.selectedLanguage
                    ]
                  }`}
              <br />
              <span className="icon-headphone" /> &nbsp;
              {this.props.agentProperties.user_Info.service_name
                ? ` ${this.props.agentProperties.user_Info.service_name}`
                : " (No Service)"}
              <br />
              {this.props.agentProperties.IVR_name && [
                 "IVR : "+ `${this.props.agentProperties.IVR_name}` ,
              <br/>]}
              <br/>
              {this.props.agentPermission.hasListenCall === 1 && (
                <Button onClick={() => this.onListen()}>
                  {this.props.translations.listen[this.props.selectedLanguage]}
                </Button>
              )}
              &nbsp;&nbsp;
              {this.props.agentPermission.hasListenCall === 1 && (
                <Button onClick={() => this.onAdvice()}>
                  {this.props.translations.advice[this.props.selectedLanguage]}
                </Button>
              )}
              &nbsp;&nbsp;
              {this.props.agentPermission.hasHangup === 1 && (
                <Button onClick={() => this.onHangUp()}>
                  {this.props.translations.hangUp[this.props.selectedLanguage]}
                </Button>
              )}
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    agentPermission: state.agentsAndSupervisors.agentPermissions,
    agentInfo: state.agentInfo,
    translations: state.languages.translations,
    selectedLanguage: state.languages.selectedLanguage,
    darkMode: state.common.darkMode,
    theme: state.common.theme,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { hangUpCall, listenCall, set_userInteraction, showWebphone },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(OnGoingCall);



// WEBPACK FOOTER //
// ./src/agent/modals/OnGoingCall.js